import { numberFormatter } from 'shared/utils/numbers/formatter';

export const formatWithPostfixOrEmpty = (value: number | string | null | undefined, postfix: string): string => {
  if (!value) {
    return '–';
  }

  const formattedValue = typeof value === 'number' ? numberFormatter(value) : value;

  return `${formattedValue} ${postfix}`;
};
